<template>
  <div class="aboutPark">
    <img src="@/assets/aboutPark3.png" class="pao pao1">
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="aboutPark_content">
      <div class="linear_word">BOONIE BEARS BAY</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">熊出没欢乐港湾</div>
      </div>
      <div class="aboutPark_pic wow fadeInRight"></div>
      <div class="wow fadeInLeft">
        <div class="welcome">宁波熊出没欢乐港湾作为宁波方特旅游度假区的配套组成部分，包含开放式主题街区、熊出没水上乐园、熊出没港湾酒店三大板块，共有二十余个室内外特色游乐项目以及近百个休闲景观、风味餐饮和特色商店，极大丰富了宁波方特旅游度假区的旅游业态，为广大游客提供了“吃住游购娱”的全方位文旅体验。</div>
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'
export default {
  components: { myMenu, myBottom, },
  data() {
    return {
    }
  },
  methods: {
    initWow(zoom) {
      var top = $('.welcome').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            $(box).removeClass('wow');
          }
        }
      );
      wow.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.aboutPark {
  .linear_word {
    font-size: 48px;
  }
  .linear_word2 {
    font-size: 48px;
    margin-top: -38px;
  }
  .pao1 {
    left: 620px;
    top: 600px;
  }
  .aboutPark_content {
    width: 1320px;
    margin: 150px auto 400px;
    position: relative;
    z-index: 1;
    .welcome {
      font-size: 24px;
      text-indent: 2em;
      width: 450px;
      margin-top: 40px;
      line-height: 50px;
      text-align: justify;
    }
    .welcome2 {
      margin-top: 10px;
    }
    .aboutPark_pic {
      width: 706px;
      height: 516px;
      margin-top: 70px;
      border: 1px solid #fff;
      border-radius: 30px;
      box-shadow: 0px 10px 20px 0px rgba(37, 135, 159, 0.38);
      background: url('@/assets/aboutPark1.jpg') no-repeat center;
      background-size: cover;
      float: right;
    }
  }
}
</style>